import { ReactComponent as ChevronRightIcon } from 'assett/icons/chevron_right_icon.svg';
import { setSelectOne } from 'feature/tableSelectedItems/tableSelectedItemsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppDispatch, RootState } from 'store/store';
import {
	Button,
	Checkbox,
	IconButton,
	TableBody,
	TableCell,
	TableRow,
	Typography,
} from 'styles';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import { getShortDate } from 'utils/utils';

export const ComplaintTrackingBody = () => {
	const { rows } = useSelector((store: RootState) => store.complaintTracking);
	const { selectedItems, downloadAll } = useSelector(
		(store: RootState) => store.tableSelectedItems,
	);
	const progressIndicator = useSelector(
		(state: RootState) => state.progressIndicator,
	);
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});
	const dispatch = useDispatch<AppDispatch>();
	const navigate = useNavigate();

	const { complaintStatuses, complaintTypes, complaintSources } = useSelector(
		(store: RootState) => store.form,
	);

	const List = rows.map(row => (
		<TableRow key={row.complaintId}>
			<TableCell sx={{ width: 44 }}>
				<Checkbox
					label=""
					sx={{ p: 0 }}
					checked={
						downloadAll
							? !selectedItems.find((el: string | number) => el === row.complaintId)
							: !!selectedItems.find((el: string | number) => el === row.complaintId)
					}
					onClick={() => dispatch(setSelectOne(row.complaintId))}
				/>
			</TableCell>
			<TableCell sx={{ width: 235 }}>
				<Typography variant="body">
					{tClientLabels('complaint.complaintNumber', {
						complaintNumber: row.complaintId,
					})}
				</Typography>
			</TableCell>
			<TableCell sx={{ width: 235 }}>
				<Button
					component={'a'}
					aria-label={`View Claim ${row.externalClaimId}`}
					variant="underline"
					onClick={() => navigate(`/view-claims/${row.claimUUID}`)}
				>
					{tClientLabels('fraud.fraudNumber', { fraudNumber: row.externalClaimId })}
				</Button>
			</TableCell>
			<TableCell sx={{ width: 235 }}>
				<Typography variant="body">
					{tDbLabels(
						complaintSources.find(c => c.code === row.complaintSource)?.label || '-',
					)}
				</Typography>
			</TableCell>
			<TableCell sx={{ width: 235 }}>
				<Typography variant="body">
					{tDbLabels(
						complaintTypes.find(c => c.code === row.complaintType)?.label || '-',
					)}
				</Typography>
			</TableCell>
			<TableCell sx={{ width: 235 }}>
				<Typography variant="body">
					{getShortDate(row.complaintNotificationDate)}
				</Typography>
			</TableCell>
			<TableCell sx={{ width: 235 }}>
				<Typography variant="body">
					{tDbLabels(
						complaintStatuses.find(c => c.code === row.complaintStatus)?.label || '-',
					)}
				</Typography>
			</TableCell>
			{
				//this is to fill the woid and make the arrow sticky at the end
			}
			<TableCell />
			{
				//this is for the reload button column
			}
			<TableCell />
			<TableCell>
				<IconButton
					onClick={() => navigate(`/view-complaint-tracking/${row.complaintId}`)}
				>
					<ChevronRightIcon />
				</IconButton>
			</TableCell>
		</TableRow>
	));

	return List && List.length > 0 ? (
		<TableBody>{List}</TableBody>
	) : List && !progressIndicator?.isLoading ? (
		<TableBody
			sx={{
				'& td': {
					paddingLeft: '0px!important',
					textAlign: 'left!important',
					backgroundColor: 'transparent!important',
				},
			}}
		>
			<TableRow>
				<TableCell colSpan={12}>
					<Typography variant="bodyLink" sx={{ width: '100%' }}>
						{tClientLabels('view-claims.noClaimsFound')}
					</Typography>
				</TableCell>
			</TableRow>
		</TableBody>
	) : null;
};
